export const LOCAL_STORAGE_SELL_TOKEN_KEY = 'mach_exchangeData_sellToken'
export const LOCAL_STORAGE_BUY_TOKEN_KEY = 'mach_exchangeData_buyToken'
